export default __webpack_public_path__ + "static/media/faraday.f6eb958c.png";